module.exports = __webpack_public_path__ + "img/trunk_1x3_z16.d873e155.svg";